import { useContext } from 'react';
import './userList.scss';
import { DataGrid } from '@mui/x-data-grid';
import { userColumns } from '../../datatablesource';
import { makeStyles } from "@material-ui/core/styles";
import { UserContext } from '../../Contexts/UserContext';
import { useMediaQuery, useTheme } from '@material-ui/core';




const useStyles = makeStyles({
    datatable: {
        height: '400px',
        backgroundColor: '#eaeaea',
        color: 'black',
        fontSize: '12px',
        borderRadius: '10px',
    },
    cellAction: {
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
    },
    headerCell: {
        backgroundColor: 'rgba(45, 45, 45, 0.8666666667)',
        color: 'white',
    },
});



const Datatable = () => {
    const { userData } = useContext(UserContext);
    const classes = useStyles();
    const theme = useTheme();
    const isSmallerScreen = useMediaQuery(theme.breakpoints.down('xs'));

    const columns = isSmallerScreen
        ? userColumns.filter((column) => column.field !== 'phone' && column.field !== 'fullname')
        : userColumns;

    const columnsWithHeaderStyle = columns.map((column) => ({
        ...column,
        headerClassName: classes.headerCell,
    }));

    return (
        <div className={classes.datatable}>
            <DataGrid
                className={classes.datatable}
                rows={userData}
                columns={columnsWithHeaderStyle}
                pageSize={5}
                rowsPerPageOptions={[5]}
                disableSelectionOnClick
            />
        </div>
    );
};

export default Datatable